// router.tsx
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from "react-router-dom";
import HomePage from "./pages/index";
import ChatPage from "./pages/ChatPage";
import ChatDashboard from "./pages/ChatDashboard";
import ThemeControl from "./components/flowbite-wrapper";
import AgentListPage from "./pages/agentList";
import ForgotPasswordPage from "./pages/authentication/forgot-password";
import ProfileLockPage from "./pages/authentication/profile-lock";
import ResetPasswordPage from "./pages/authentication/reset-password";
import SignInPage from "./pages/authentication/sign-in";
import SignUpPage from "./pages/sign-up";
import UserProfilePage from "./pages/profile";
import UserSettingsPage from "./pages/settings";
import TicketDashboard from "./pages/ticketList/TicketList";
import LoginPage from "./pages/LoginPage";
import AuthGuide from "./components/AuthGuide";
import RequestList from "./pages/RequestList";
import TicketDetails from "./pages/ticketDetails/TicketDetails";

export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route>
      <Route element={<AuthGuide />}>
        <Route element={<ThemeControl />}>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<ChatDashboard />} index /> {/* New dashboard as home page */}
          <Route path="/home" element={<HomePage />} /> {/* Old home page moved to /home */}
          <Route path="/dashboard" element={<ChatDashboard />} /> {/* Also accessible at /dashboard */}
          <Route path="/chat" element={<ChatPage />} /> {/* New prop-based route */}
          <Route path="/authentication/sign-in" element={<SignInPage />} />
          <Route path="/requestList" element={<RequestList />} />
          <Route path="/signup" element={<SignUpPage />} />
          <Route
            path="/authentication/forgot-password"
            element={<ForgotPasswordPage />}
          />
          <Route
            path="/authentication/reset-password"
            element={<ResetPasswordPage />}
          />
          <Route
            path="/authentication/profile-lock"
            element={<ProfileLockPage />}
          />
          <Route path="/tickets" element={<TicketDashboard />} />
          <Route path="/tickets/:ticketId" element={<TicketDetails />} />
          <Route path="/settings" element={<UserSettingsPage />} />
          <Route path="/profile" element={<UserProfilePage />} />
          <Route path="/agentList" element={<AgentListPage />} />
          <Route path="/agents/profile" element={<UserProfilePage />} />
          <Route path="/agents/settings" element={<UserSettingsPage />} />
        </Route>
      </Route>
    </Route>,
  ),
);
